<template>
  <div id="container" v-loading="loading">
    <!-- <div @click="isOK=false">竞拍失败</div>
    <div @click="isOK=true">竞拍成功</div> -->
    <h1 class="full_layout terms_title">{{$t('base.offerHistory')}}</h1>
    <div class="full_layout bid_history_box" v-if="list!=null">
      <span class="el-icon-error text_red span_alert" v-if="list.Status==-2&&Status!=1">{{$t('alert.bought')}}</span>
      <span class="el-icon-error text_red span_alert" v-if="Status==2||Status==3&& priceBid&&list.Status>0">{{$t('alert.noAcceptOffer')}}</span>
      <span class="el-icon-success text_greed span_alert" v-if="Status==1&& priceBid">{{$t('alert.acceptedOffer')}}</span>
      <span class="icon_history text_greed span_alert" v-if="Status==0&& priceBid&&list.Status>0">{{$t('alert.waitReply')}}</span>
      <div class="contact_box like_box" v-if="this.list!=''" :class="list.Status==-2?'sold':''">
        <div v-if="list.Status==-2" class="iconsold"></div>
        <el-image class="like_img" :src="list.TitImg" fit="contain"></el-image>
        <div class="like_detail">
          <p>{{list.Title}}</p>
          <span>{{areaSymbol}} {{list.USD_Price}}</span>
        </div>
      </div>
      <div class="contact_box" :class="list.Status==-2?'sold':''">
        <div class="bid_history_info" v-if="priceBid">
          <span class="text_gray">{{$t('colon.offer')}}</span>
          <div class="text_blue">{{areaSymbol}} <em>{{priceBid}}</em></div>
        </div>
        <div class="bid_history_info_box">
          <div class="bid_history_info" v-if="Status==0"><span class="text_gray">{{$t('colon.answer')}}&nbsp;</span>{{CountDown(Createdate)}}</div>
          <div class="bid_history_info"><span class="text_gray">{{$t('colon.offerLeft')}}&nbsp;</span>{{list.BargainCount}} {{$t('base.of')}} 3</div>
          <div class="bid_history_info"><span class="text_gray">{{$t('colon.timeLeft')}}&nbsp;</span><span :class="getDown(list.EffectiveTime)==1?'text_red':''">{{CountDown(list.EffectiveTime)}}</span></div>
          <div class="bid_history_info"><span class="text_gray">{{$t('colon.timeEnd')}}&nbsp;</span><span :class="getDown(list.EffectiveTime)==1?'text_red':''">{{list.EffectiveTime|setTime}}</span></div>
          <!-- {{progress.SRStatus ==2?'Completed':'Rescinded'}} -->
        </div>
        <!-- <el-button type="primary" @click="getAuctionCheck()" v-if="list.EffectiveTimeStr!='Ended listing'&&list.BargainCount<3&&Status!=0&&userInfo.MappingUserId!=list.SellUserID">Make offer</el-button> -->
        <el-button class="Make_offer" @click="getAuctionCheck()" v-if="list.EffectiveTimeStr!='Ended listing'&&list.BargainCount<3&&Status==null&&userInfo.MappingUserId!=list.SellUserID">{{$t('base.makeOffer')}}</el-button>
        <el-button type="primary" @click="setAuctionCheck(Status)" v-if="list.EffectiveTimeStr!='Ended listing'&&list.BargainCount<=3&&Status==null&&userInfo.MappingUserId!=list.SellUserID">{{Status!=2&&Status>1?$t('base.buyNow'):$t('base.accept')}}</el-button>
        <el-button class="Make_offer" @click="getAuctionCheck()" v-if="list.EffectiveTimeStr!='Ended listing'&&list.BargainCount<3&&Status>1&&userInfo.MappingUserId!=list.SellUserID">{{$t('base.makeOffer')}}</el-button>
        <el-button type="primary" @click="setAuctionCheck(Status)" v-if="list.EffectiveTimeStr!='Ended listing'&&list.BargainCount<=3&&Status>1&&userInfo.MappingUserId!=list.SellUserID">{{Status!=2&&Status>1?$t('base.buyNow'):$t('base.accept')}}</el-button>
        <!-- pay now -->
        <el-button type="primary" @click="setPayNow()" v-if="list.EffectiveTimeStr=='Ended listing'&&list.BargainCount<3&&Status==1&&orderId!=0&&userInfo.MappingUserId!=list.SellUserID">
          {{$t('base.payNow')}}
        </el-button>
      </div>
      <div class="bid_list_box">
        <div class="bid_list table_th_gray">
          <div>{{$t('base.offer')}}</div>
          <div>{{$t('base.offerAmount')}}</div>
          <div>{{$t('base.offerRemark')}}</div>
          <div>{{$t('base.offerTime')}}</div>
        </div>
        <div class="bid_list" v-for="(item,index) in bidList" :key="index">
          <div><span>{{item.RealName}}
              <!-- ({{item.BuyFavorableCount}}) --></span><span v-if="item.MemberSource != userInfo.MemberSource" class="earth" :class="item.MemberSource"></span></div>
          <div>{{areaSymbol}} {{item.US_Price}}</div>
          <div class="line_txt1">{{item.Remark}}</div>
          <div>{{item.Createdate|setTime}}</div>
        </div>
      </div>
      <!-- <p class="text_gray">Gray italic text indicates an automatic bid (proxy bid) placed by eBay on behalf of the bidder. lf two people bid the sameamount, the first bid has priority.Trading cards are not eligible for bid retraction.</p> -->
    </div>
    <make-offer :makeVisible="dialogVisible" @getDialog="getDialog" :list="list" v-if="list!=null" />
  </div>
</template>
<script>
/* 模拟假数据 */
import MakeOffer from "@/components/dialog/makeoffer";
import bus from '@/api/bus';
import { countDown, setUTC, getInfo, priceExchange, CensoredName, getTime } from "@/api/public";
import qs from 'qs'
export default {
  name: 'tabslist',
  components: { MakeOffer },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      loading: false,
      cid: '',
      userInfo: null,
      isOK: null,
      nowData: new Date().getTime(),
      dialogVisible: false,
      list: null,
      bidList: '',
      isAuction: false,
      isread: true,
      priceBid: '',
      offerid: '', // 议价id
      Createdate: '',
      orderId: 0, // 订单id
      Status: null
    }
  },
  filters: {
    // setName(val) {
    //   return CensoredName(val)
    // },
    setTime(val) {
      val = val.toString().replace(/-/g, "/")
      return getTime(val, -8, '', 'cn')
    }
  },
  created() {
    bus.$emit('headerTitle', this.$t('base.myCardHobby'));
    this.cid = this.$route.params.id
    this.userInfo = getInfo()
    this.getDetail();
    this.getBargain();
    this.cardTimer()
  },
  mounted() {},
  methods: {
    getAuctionCheck() {
      let that = this;
      that.dialogVisible = true
    },
    // 弹框关闭
    getDialog(val) {
      this.dialogVisible = val
      this.getBargain()
      this.getDetail()
    },
    // 获取商品详情
    getDetail() {
      this.loading = true
      let that = this;
      let data = { 'memberid': '', 'CommodityID': this.cid }
      if (that.userInfo != null) {
        data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'CommodityID': this.cid }
      }
      that.$get(that.$interface.DetailCommodity, data).then(res => {
        if (res.result != 0) {
          let result = res.data
          result.HighestPrice = priceExchange(result.HighestPrice, 'USD')
          that.list = result;
        }
        that.loading = false
      })
    },
    setAuctionCheck(val) {
      let that = this;
      let data = "";
      if (val == 2) {
        this.$confirm("<div style='align-items: center'>"+that.$t('alert.confirmOrder')+"</div>", that.$t('symbol.confirmOrder'), {
          confirmButtonText: that.$t('base.confirm'),
          cancelButtonText: that.$t('base.cancel'),
          dangerouslyUseHTMLString: true,
          lockScroll: false
        }).then(() => {
          data = {
            'memberid': that.userInfo.MappingUserId,
            'token': that.userInfo.ChineseToken,
            'operator_id': that.userInfo.MappingUserId,
            'id': that.offerid,
            'ApproveType': 1
          }
          that.loading = true
          that.$post(that.$interface.Approve, qs.stringify(data)).then(res => {
            if (res.result != 0) {
              this.$router.push({
                path: '/mycardhobby/purchase?type=1'
              })
            } else {
              this.$message({
                message: res.msg,
                duration: 1000,
                type: 'error'
              });
            }
            that.loading = false

          })
        }).catch(() => {});

      } else {
        data = {
          "HeadPortrait": "https://bucket-katao.oss-cn-hangzhou.aliyuncs.com/touxiang.png",
          "SellRealName": this.list.SellRealName,
          "BuyerWyAccId": this.userInfo.MappingUserId,
          "SellerWyAccId": this.list.SellUserID,
          "Details": [{
            "ID": this.list.ID,
            "Title": this.list.Title,
            "TitImg": this.list.TitImg,
            "USD_Price": this.list.USD_Price,
          }],
          'OrderType': this.list.OrderType,
          "USD_PostageMoney": this.list.PostageMoney,
          "USD_TotalPrice": this.list.USD_Price
        }
        window.sessionStorage.setItem('check', JSON.stringify(data))
        this.$router.push({
          name: 'Checkout'
        })
      }
    },
    // 获取议价列表
    getBargain() {
      let that = this;
      let data = { 'memberid': '', 'CommodityID': this.cid }
      if (that.userInfo != null) {
        data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'CommodityID': this.cid }
      }
      that.$get(that.$interface.BargainList, data).then(res => {
        if (res.result != 0) {
          let result = res.data;
          let orderId = 0;
          if (res.data.length > 0) {
            result.map(r => {
              if (r.OrderId != 0 && r.OrderId != undefined) {
                orderId = r.OrderId
              }
              if (r.BargainType == 1) {
                r.RealName = 'Me'
              }
              if (r.Status == 3) {

              }
            })
            that.orderId = orderId;
            if (result[0].BargainType == 1) {
              that.offerid = result[0].ID
              that.priceBid = result[0].US_Price;
              that.Status = result[0].Status;
              that.Createdate = new Date(result[0].Createdate);
              that.Createdate.setHours(that.Createdate.getHours() + 48)
            } else if (result[1].BargainType == 1) {
              that.offerid = result[0].ID
              that.priceBid = result[1].US_Price;
              that.Status = result[1].Status;
              that.Createdate = new Date(result[1].Createdate);
              that.Createdate.setHours(that.Createdate.getHours() + 48)
            } else {
              that.priceBid = ''
              that.Status = null
            }

          }
          that.bidList = result;
        }
        that.loading = false
      })
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    // 判断是否小于等于1分钟
    getDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      //console.log(itemEnd)
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(itemEnd, this.nowData, 0)
    },
    //
    CountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(itemEnd, this.nowData)
    },
    ReplyCountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      console.log(111, itemEnd)
      return countDown(itemEnd, this.Createdate)
    },
    // 跳转去支付页面
    setPayNow() {
      let that = this
      let details = [{ "ID": this.list.ID }]
      let BusinessType = 1
      if (this.list.MemberSource != this.userInfo.MemberSource) {
        BusinessType = 2
      }
      let data = {
        "BusinessType": BusinessType,
        "Details": details,
      }
      window.sessionStorage.setItem('check', JSON.stringify(data))
      this.$router.push({
        path: '/pay/checkout/' + that.orderId
      })
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/terms.css";

.earth {
  margin-left: 10px;
  padding: 0 16px 0 0;
  background: url(/static/images/icon/icon_earth.svg) no-repeat 100% 50%;
}

.bid_history_box {
  margin-bottom: 24px;
}

.contact_box {
  /* width: 544px; */
  margin-bottom: 24px;
  position: relative;
}

.contact_box.sold {
  position: relative;
}

.contact_box.sold .like_img {
  opacity: .3
}

.contact_box.sold .iconsold {
  position: absolute;
  z-index: 2;
  font-size: 20px;
  font-weight: 700;
  width: 56px;
  height: 40px;
  cursor: pointer;
  background: url(../../../static/images/soldout.svg) center no-repeat;
  background-size: contain;
  top: 24px;
  left: 18px;
}

.like_box {
  display: flex;
}

.like_box .like_img {
  width: 88px;
  height: 88px;
  background-color: #e0e0e0;
  border-radius: 6px;
  margin-right: 12px;
}

.like_detail {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80%;
  font-size: 16px;
}

.bid_list_box {
  border-top: 1px solid #e0e0e0;
  padding-top: 24px;
  margin-bottom: 16px;
}

.bid_list {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  height: 48px;
  align-items: center;
}

.bid_list>div {
  width: 33%;
  padding: 0 12px;
}

.span_alert {
  padding: 16px;
  border: 1px solid #e0e0e0;
  background-color: #f7f7f7;
  border-radius: 4px;
  min-width: 300px;
  display: inline-block;
  margin-bottom: 24px;
}

.span_alert.el-icon-error {
  border-color: #F9D2D2;
  background-color: #FDF4F4;
}

.bid_history_info {
  width: 544px;
  display: flex;
  margin-bottom: 24px;
  font-size: 16px;
}

.bid_history_info>span {
  display: flex;
  align-items: center;
}

.bid_history_info .text_gray {
  margin-right: 8px;
}

.bid_history_info>div {
  display: flex;
  align-items: flex-end;
}
.contact_box.sold .bid_history_info>div{
  color: #a0a0a0;
}

.bid_history_info>div>em {
  font-size: 24px;
  line-height: 0.9;
  font-weight: bold;
  margin-left: 2px;
}

.bid_history_info_box {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.bid_history_info_box .bid_history_info>span {
  width: auto;
}

.icon_history:before {
  content: "";
  background: url(../../../static/images/icon/icon_history_yes.svg) no-repeat;
  line-height: 1;
  padding-right: 25px;
  font-size: 16px;
  background-position-y: center;
}

.span_alert.icon_history {
  color: #5F6DAE;
  border-color: #DFE2EF;
  background-color: #F0F3FF;
}

.Make_offer {
  color: #5F6DAE;
  border: #5F6DAE 1px solid;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/offerhistory.vue